import React, { useEffect } from 'react'

import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'

import { TError } from 'config/types'
import { getAppIdCookie } from 'utils/token'

// eslint-disable-next-line max-len
import { fetchChatsAction } from 'containers/dashboard/features/cloud/components/tabs/chat/store/actions'
import EmulatorEmpty from 'containers/emulator/components/emulator-empty/EmulatorEmpty'
import Preloader from 'components/preloader/Preloader'
import { RootState } from 'redux/reducers/rootReducer'
import ChatView from './components/chat-view/ChatView'

const ChatPage = () => {
    const { t, i18n } = useTranslation(['toast'])
    const dispatch = useDispatch()

    const { chatsDetails } = useSelector((state: RootState) => state.chat)

    const appId = getAppIdCookie()

    useEffect(() => {
        if (!appId) return
        dispatch(
            fetchChatsAction({
                appId,
                language: i18n.language,
                callback: (type: string, errorArray?: TError[]) => {
                    if (type === 'error') {
                        errorArray?.forEach(err => {
                            console.error(err.description)
                            toast.error(t('toast:backendError'))
                        })
                    }
                },
            }),
        )
    }, [appId, dispatch, t, i18n.language])

    return chatsDetails ? (
        chatsDetails.length > 0 ? (
            <ChatView data={chatsDetails} />
        ) : (
            <EmulatorEmpty />
        )
    ) : (
        <Preloader />
    )
}
export default ChatPage as React.FC
